export default "__VITE_ASSET__0RgNdqfv__"